import { FaYoutube } from 'react-icons/fa';
import { PreviewCardShell } from './PreviewCardShell';

interface YouTubeVideoMockupProps {
  title: string;
  channelName?: string;
  views?: string;
  uploadDate?: string;
  duration?: string;
  thumbnailText?: string;
  previewLabel?: string;
  hideShell?: boolean;
}

export const YouTubeVideoMockup = ({
  title,
  channelName = 'Channel Name',
  views = '0',
  uploadDate = 'Just now',
  duration = '0:00',
  thumbnailText,
  previewLabel = 'YouTube Video Preview',
  hideShell = false,
}: YouTubeVideoMockupProps) => {
  const content = (
    <>
        {/* Thumbnail - 16:9 aspect ratio */}
        <div className="relative bg-gradient-to-br from-zinc-700 to-zinc-900 rounded-lg overflow-hidden mb-3" style={{ aspectRatio: '16/9' }}>
          {/* Thumbnail text */}
          {thumbnailText && (
            <div className="absolute inset-0 flex items-center justify-center p-4">
              <p className="text-white text-center text-2xl font-bold drop-shadow-lg line-clamp-3">{thumbnailText}</p>
            </div>
          )}

          {/* Duration badge */}
          <div className="absolute bottom-2 right-2 bg-black/90 text-white text-xs px-1.5 py-0.5 rounded font-semibold">
            {duration}
          </div>
        </div>

        {/* Video info */}
        <div className="flex gap-3">
          {/* Channel avatar */}
          <div className="w-9 h-9 rounded-full bg-gradient-to-br from-red-400 to-red-600 flex-shrink-0" />

          <div className="flex-1 min-w-0">
            {/* Title */}
            <h4 className="mb-1 line-clamp-2 text-sm font-semibold text-zinc-50">{title}</h4>

            {/* Channel name */}
            <p className="text-xs text-zinc-400">{channelName}</p>

            {/* Views and date */}
            <p className="text-xs text-zinc-400">
              {views} views · {uploadDate}
            </p>
          </div>
        </div>
    </>
  );

  if (hideShell) {
    return content;
  }

  return (
    <PreviewCardShell
      className="mb-3 w-full max-w-md"
      bodyClassName="p-3"
      badgeClassName="bg-[#FF0000]"
      badge={<FaYoutube className="h-5 w-5 text-white" />}
      label={previewLabel}
    >
      {content}
    </PreviewCardShell>
  );
};
